import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'libs/form'
import { Sale } from 'features/sales/types/sales.types'

interface UsePopulateSaleProps {
	data: Sale | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateSale = ({ data, reset }: UsePopulateSaleProps) => {
	useEffect(() => {
		if (data) {
			reset({
				created: data.created,
				commission_percentage: data.commission_percentage,
				payout: data.payout,
				product_sku: data.product.sku,
				receipt_reference: data.receipt_reference,
				product_name: data.product.name,
				unit_price: data.product.price.amount,
				quantity: data.quantity,
				vat_percentage: data.vat_percentage,
				vat_amount: data.vat.amount,
				subtotal: data.subtotal.amount,
				discount: data.discount.amount,
				total: data.total.amount,
				commission_amount: data.commission.amount,
				user: data.account.name
			})
		}
	}, [data])
}
